<button mat-button class="close-button" [mat-dialog-close]="false">
  <mat-icon>close</mat-icon>
</button>

<div class="search-input-container flex-row">
  <mat-form-field class="search-guests-form-field" subscriptSizing="dynamic">
    <mat-label translate="VOLUNTEER.SELECT_GUEST.INPUT_LABEL"></mat-label>
    <mat-icon matPrefix class="search-icon">search</mat-icon>
    <input matInput type="search" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" />
  </mat-form-field>
</div>

<mat-list class="gb-guest-list" role="list" cdkFocusRegionstart>
  <mat-list-item class="add-guest-item" [mat-dialog-close]="'register'">
    <div class="flex-row flex-justify-start flex-align-center">
      <span class="gb-guest-icon">
        <mat-icon>person_outline</mat-icon>
      </span>
      <div class="flex-col flex-justify-center flex-align-start">
        <p>
          {{ 'VOLUNTEER.SELECT_GUEST.NOT_THERE' | translate }}
          <span class="registration-link">
            {{ 'VOLUNTEER.SELECT_GUEST.REGISTER_NOW' | translate }}
          </span>
        </p>
      </div>
    </div>
  </mat-list-item>

  <ng-container *ngIf="(isLoading$ | async) === false; else showLoader">
    <ng-container *ngIf="allProfiles$ | async as profileList">
      <mat-list-item
        *ngFor="let profile of profileList"
        (click)="onGuestSelect(profile)"
        [mat-dialog-close]="'success'"
        class="guest-item"
      >
        <div class="gb-guest-item">
          <div class="gb-guest-name-icon-container">
            <div class="flex-col flex-justify-start flex-align-center">
              <span class="gb-guest-icon">
                <mat-icon>person</mat-icon>
              </span>
            </div>
            <div class="flex-col flex-justify-start flex-align-center flex-grow">
              <span> {{ profile | gbDisplayName }} </span>
            </div>
          </div>
          <div class="flex-col flex-justify-start flex-align-center">
            <span class="phone">
              {{ profile.identity | gbReplaceChars: '*':'•' }}
            </span>
          </div>
        </div>
      </mat-list-item>

      <div *ngIf="profileList.length === 0" class="no-results flex-row-center">
        <span>{{ 'VOLUNTEER.SELECT_GUEST.NO_RESULTS_FOUND' | translate }}</span>
      </div>
    </ng-container>
  </ng-container>
</mat-list>

<mat-paginator
  #paginator
  [length]="profilesCount$ | async"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  (page)="getProfiles($event)"
>
</mat-paginator>

<ng-template #showLoader>
  <div class="loader-container flex-row flex-align-center flex-justify-center">
    <gb-loading-spinner [showLoader]="isLoading$" [disableBackdrop]="true"> </gb-loading-spinner>
  </div>
</ng-template>
